import { render, staticRenderFns } from "./TopicSponsorshipList.vue?vue&type=template&id=278c2967&"
import script from "./TopicSponsorshipList.vue?vue&type=script&lang=js&"
export * from "./TopicSponsorshipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports